import React, { useState, useEffect } from "react";
import Styles from '../Style/Common.module.css';
import { getWhoWeAreAPI } from "../../services/routes.services";
import CountUp from 'react-countup';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CustomButtonGroup from "../Common/CustomButtonGroup";
import parse from 'html-react-parser';
const TQRank = ()=>{
    const [weAreData, setWeAreData] = useState([]);
    const valueSlide = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 3
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 580 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 580, min: 0 },
      items: 1
    }
  };
    useEffect(()=>{
        getWhoWeAreAPI().then((res)=>{
            setWeAreData(res?.data?.whoweare[0]?.fields);
        });
    }, [])

    function formatNumber(num) {
        if (num >= 1000) {
          const k = Math.floor(num / 1000);
          return `${k}K+`;
        }
        return num.toString();
      }
      console.log(weAreData)
    return(
        <div className={Styles.areRank}>
            <div className={'navBtn ' + Styles.valueOwl}>
              <Carousel
                  autoPlaySpeed={5000}
                  transitionDuration={500}
                  responsive={valueSlide}
                  autoPlay={true}
                  infinite={true}
                  arrows={false}
                  customButtonGroup={<CustomButtonGroup />}
                  renderButtonGroupOutside={true}
                  containerClass="valueOwl"
              >
                  {weAreData && weAreData.map((item, index) => (
                  <div className={Styles.valueSlide} key={index}>
                      <h4>{parse(item?.field1)}</h4>
                      <p>{parse(item?.field2)}</p>
                  </div>
                  ))}
              </Carousel>
            </div>
        </div>
    )
}

export default TQRank;